import { useCallback, MouseEvent, ReactElement } from "react";
import { StripePaymentContext } from "@/lib/hooks/usePaymentCommon";

export function SubmitButton({
  canSubmit,
  onSubmit,
  submitButtonText,
}: {
  canSubmit: boolean;
  onSubmit: (stripePaymentContext?: StripePaymentContext) => void;
  submitButtonText: string;
}): ReactElement {
  const handleClick = useCallback(
    (event: MouseEvent<HTMLInputElement>) => {
      event.preventDefault();
      onSubmit();
    },
    [onSubmit],
  );

  return (
    <input
      type="submit"
      onClick={handleClick}
      value={submitButtonText}
      disabled={!canSubmit}
    />
  );
}
